// extracted by mini-css-extract-plugin
export default {"container":"Qualification_container__99YEB","content":"Qualification_content__3bvb+"};